<template>
	<div class="display-flex flex-column width-100 height-100">
		<div class="display-flex flex-row width-100 flex-justify-space-between">
			<div class="type-text">Type</div>
			<FeatureBackgroundRadioMenu @change-background-mode="(v) => (backgroundMode = v)" :backgroundMode="backgroundMode" />
		</div>
		<v-expand-x-transition>
			<FeatureBackgroundImageSelectionMenu
				class="mt-4"
				:backgroundImageSrc="backgroundImageSrc"
				v-if="isImageMode"
				@change-background-image="(v) => (backgroundImageSrc = v)"
			/>
			<InputColorPicker
				title="Text Color"
				:color.sync="backgroundImageSrc"
				:iconName="'background-sample-icon'"
				v-else-if="isColorMode"
				class="flex-centerize pl-5 mt-3 width-100 color-picker-container"
			/>
		</v-expand-x-transition>
		<SettingSwitch
			title="Show background on mobile"
			:switchValue.sync="isMobileBackgroundEnabled"
			description="Set whether mobile users see the background or a white background"
		/>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import InputColorPicker from '@/components/common/InputColorPicker';
import { updateWorkflowSetting } from '@/store/modules/selectedWorkflow/actions.js';
import { getWorkflowAppearanceSettings } from '@/store/modules/selectedWorkflow/getters.js';
import FeatureBackgroundRadioMenu from '@/components/BlockEditorWidget/FieldSettings/PageOptions/FeatureBackgroundRadioMenu';
import FeatureBackgroundImageSelectionMenu from '@/components/BlockEditorWidget/FieldSettings/PageOptions/FeatureBackgroundImageSelectionMenu';
import SettingSwitch from '@/components/BlockEditorWidget/FieldSettings/WidgetSettings/SettingSwitch';
import { BackgroundMode } from '@ply-io/ply-front-shared-utilities';

function getWorkflowSettingsComputed(key, defaultValue) {
	return {
		get() {
			return this.workflowAppearanceSettings[key] || defaultValue;
		},
		set(value) {
			this.updateWorkflowVersionSettings({ key, value });
		},
	};
}

export default {
	name: 'FeatureBackgroundImageMenu',
	components: {
		SettingSwitch,
		InputColorPicker,
		FeatureBackgroundRadioMenu,
		FeatureBackgroundImageSelectionMenu,
	},
	computed: {
		...mapGetters([getWorkflowAppearanceSettings.fullPath]),
		workflowAppearanceSettings() {
			return this[getWorkflowAppearanceSettings.fullPath];
		},
		backgroundMode: getWorkflowSettingsComputed('background_mode', BackgroundMode.Off),
		isMobileBackgroundEnabled: getWorkflowSettingsComputed('mobile_background_enabled', false),
		backgroundImageSrc: {
			set(value) {
				this.updateWorkflowVersionSettings({ key: 'background', value });
			},
			get() {
				if (this.isImageMode) {
					return this.workflowAppearanceSettings.background || this.workflowAppearanceSettings.background_file;
				} else {
					return this.workflowAppearanceSettings.background;
				}
			},
		},
		isImageMode() {
			return this.backgroundMode === BackgroundMode.Image;
		},
		isColorMode() {
			return this.backgroundMode === BackgroundMode.BackgroundColor;
		},
	},
	methods: {
		...mapActions([updateWorkflowSetting.fullPath]),
		updateWorkflowVersionSettings(payload) {
			this[updateWorkflowSetting.fullPath](payload);
		},
	},
};
</script>
<style scoped lang="scss">
.radio-menu-container {
	border-radius: 6px;
	background: #f9fafc;
	border: 1px solid #e7eaf3;
}

.type-text {
	font-size: 12px;
	color: var(--primary-font-color);
}
.color-picker-container {
	::v-deep {
		.vc-sketch-field {
			.vc-editable-input {
				left: 100px;
			}
		}
		.vc-sketch {
			width: 380px;
		}
	}
}
</style>
